export default "/images/frontPageBackgroundImage.jpg?b0e313ca6aed0e770960781e9711acab";